/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import Select from 'react-select';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import { MultiVerticalBar } from '../components/charts/MultiVerticalBar';
import Spinner from '../components/spinner/Spinner';
import useFetchAnalytics from '../hooks/useFetchAnalytics';
import useFetchData from '../hooks/useFetchData';
import { LineGraph } from '../components/charts/LineGraph';

function PaidModulesStudentProgressAnalytics() {
  const [paidModuleId, setPaidModuleId] = useState('');
  const [paidModuleName, setPaidModuleName] = useState('');
  const [paidCohortId, setPaidCohortId] = useState('');
  const [paidCohortName, setPaidCohortName] = useState('');

  // get modules
  const { data: paidModules } = useFetchData(
    ['course-modules', true],
    `/course-modules`,
    {
      params: { is_paid_module: true },
    },
    "Couldn't fetch paid modules. Please try again!",
    true
  );

  const moduleOptions = paidModules
    ? paidModules?.data?.course_modules
        .filter((paidModule) => paidModule.is_published)
        .map((paidModule) => ({
          value: paidModule.id,
          label: paidModule.moduleName,
        }))
    : [];

  const { data: paidCohorts } = useFetchData(
    ['paid-cohorts'],
    '/paid-cohorts',
    {},
    "Couldn't get paid cohorts. Please try again!",
    true
  );

  const paidCohortOptions = paidCohorts?.data?.paid_cohorts
    ? paidCohorts?.data?.paid_cohorts?.map((paid_cohort) => ({
        value: paid_cohort.id,
        label: `${paid_cohort.name} (${
          paid_cohort.no_of_students || 0
        } Students)`,
      }))
    : [];
  const cohortOptions = [
    {
      value: 'f5582d84-5b9a-4667-a983-a147bbf1c010',
      label: 'Default Cohort',
    },
    ...paidCohortOptions,
  ];

  const { data, isLoading } = useFetchAnalytics(
    ['paid-cohort-students-progress', paidCohortId, paidModuleId],
    `/students-progress/paid-cohort`,
    { params: { paid_cohort_id: paidCohortId, module_id: paidModuleId } },
    "Couldn't get students progress results. Please try again",
    paidCohortId && paidModuleId
  );

  return (
    <AnalyticsPageLayout
      title="Paid Modules Student Progress"
      description="Week-by-week completion for each paid module, segmented by paid cohort."
    >
      <div className="grid grid-cols-4 gap-3 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
        <Select
          isClearable
          placeholder="Select Paid Cohort"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={cohortOptions}
          onChange={(event) => {
            setPaidCohortName(event?.label ?? null);
            setPaidCohortId(event?.value || null);
          }}
        />
        <Select
          isClearable
          placeholder="Select Role-Based Module"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={moduleOptions}
          onChange={(event) => {
            setPaidModuleId(event?.value || null);
            setPaidModuleName(event?.label || null);
          }}
        />
      </div>
      {paidModuleId && paidCohortId && isLoading ? (
        <div className="flex items-center justify-center bg-white rounded-xl border border-gray-200 shadow-sm py-10">
          <Spinner />
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
          <LineGraph
            title={`${paidModuleName ?? ''} Module Progress ${
              paidCohortName ? ` - ${paidCohortName}` : ''
            }`}
            colour="#8b173b"
            datasets={data ? data?.data?.graph_data.datasets : []}
            labels={data ? data?.data?.graph_data.labels : []}
            label="Number of students"
          />
        </div>
      )}
    </AnalyticsPageLayout>
  );
}

export default PaidModulesStudentProgressAnalytics;
